const env = {
  state: {
    VUE_APP_NAME: process.env.VUE_APP_NAME,
    VUE_APP_REGISTER_BASE_URL: process.env.VUE_APP_REGISTER_BASE_URL,
  },
}

export default env
